var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-[200px] h-[387px] mx-auto my-[20px] relative"},[_c('div',{staticClass:"absolute top-[50%] translate-y-[-50%]"},[_c('img',{staticClass:"w-full h-[200px]",attrs:{"src":require("../assets/list_blank.png"),"alt":""}}),_c('h2',{staticStyle:{"color":"#CCCCCC","font-size":"16px"}},[_vm._v("No items found")])])])
}]

export { render, staticRenderFns }